import { connect } from 'react-redux';
import { IState } from '../../reducers';
import { fetchEventItemsAction } from './actions/fetchEventsItems';

import {LatestEventsBlock} from './latestEventsListBlock';

const mapStateToProps = (state: IState) => ({
    eventItems: state.eventsAndNewsItems.eventItemDto.eventItems
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchEventItems: () => dispatch(fetchEventItemsAction())
});

export const LatestEventsListBlockContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LatestEventsBlock);


// WEBPACK FOOTER //
// ./src/components/latestEventsListBlock/latestEventsListBlockContainer.tsx